import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { formService } from "../../../../services/api/formService";
import Loading from "../../components/Loading";
import DragDrop from "../../components/DragDrop";
import CustomSelect from "../../components/CustomSelect";
import CustomInput from "../../components/CustomInput";
import { NhomSelectData } from "../../../../utils/NhomSelectData";
import { useNavigate } from "react-router-dom";
import AdditionalInfoFields from "../components/AdditionalInfoFields";
import Button from "../../components/Button";

const DynamicForm = ({
  formData,
  initData,
  data,
  id,
  serviceId,
  token_client,
  serviceName,
  isEdit = false,
  category,
  representData = {
    companyName: "Công ty TNHH Masterbrand",
    address:
      "Số 104/13 Nguyễn Thái Sơn, Phường Hạnh Thông, Thành phố Hồ Chí Minh, Việt Nam",
  },
  branData,
  isMobile,
}) => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState({});
  const [files, setFiles] = useState({});
  const [sectionData, setSectionData] = useState({});
  const [loading, setLoading] = useState(false);
  // const [imageSrc, setImageSrc] = useState(null);
  // const [imageFile, setImageFile] = useState(null);
  const represent = representData;
  // const [represent, setRepresent] = useState(representData);
  const [brand, setBrand] = useState(branData || "");
  const [isLookup, setIsLookup] = useState(true);
  const [isRequire, setIsRequire] = useState(false);
  const [isOriginal, setIsOriginal] = useState(false);
  const [contentRequire, setContentRequire] = useState("");
  const [contentRequireError, setContentRequireError] = useState("");

  useEffect(() => {
    if (!isRequire) {
      setContentRequire("");
      setContentRequireError("");
    }
  }, [isRequire]);

  useEffect(() => {
    if (contentRequire.trim()) setContentRequireError("");
  }, [contentRequire]);

  // const handleRepresentChange = (field, value) => {
  //   setRepresent((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // Initialize section data
  useEffect(() => {
    // if (data) setImageSrc(data.profile_image);
    const initialSectionData = {};

    if (formData) {
      formData.profiles?.forEach((profile, profileIdx) => {
        profile.data?.forEach((section, secIdx) => {
          const sectionKey = `${profileIdx}-${secIdx}`;
          initialSectionData[sectionKey] = [
            {
              name: section.type,
              id: Date.now(),
              fields: section.fields.flat(),
            },
          ];
        });
      });
      setSectionData(initialSectionData);
    }

    // Đồng bộ số lượng fields giữa initData và formData
    if (initData) {
      const initialFormState = {};
      initData.profiles?.forEach((profile, profileIdx) => {
        profile.data?.forEach((section, secIdx) => {
          const sectionKey = `${profileIdx}-${secIdx}`;

          // Nếu số lượng fields trong initData nhiều hơn formData, thêm các fields bị thiếu
          if (
            initialSectionData[sectionKey] &&
            initialSectionData[sectionKey][0].fields.length <
              section.fields.flat().length
          ) {
            const missingFields = section.fields
              .flat()
              .slice(initialSectionData[sectionKey][0].fields.length);
            setSectionData((prev) => ({
              ...prev,
              [sectionKey]: [
                {
                  ...prev[sectionKey][0],
                  fields: [...prev[sectionKey][0].fields, ...missingFields],
                },
              ],
            }));
          }

          // Thiết lập giá trị ban đầu cho các fields
          section.fields?.flat().forEach((field, fieldIdx) => {
            const key = `${sectionKey}-${Date.now()}-${fieldIdx}`;
            try {
              if (Array.isArray(field.value)) {
                // Nếu đã là mảng thì dùng luôn
                initialFormState[key] = field.value;
              } else if (
                typeof field.value === "string" &&
                field.value.trim().startsWith("[") &&
                field.value.trim().endsWith("]")
              ) {
                // Nếu là chuỗi có dạng mảng → parse JSON
                const parsed = JSON.parse(field.value);
                initialFormState[key] = Array.isArray(parsed)
                  ? parsed
                  : field.value;
              } else {
                // Còn lại: text, object thường, null...
                initialFormState[key] = field.value || "";
              }
            } catch (err) {
              console.warn("Lỗi parse field.value:", field.name, field.value);
              initialFormState[key] = field.value || "";
            }
          });
        });
      });

      setFormState((prev) => ({ ...prev, ...initialFormState }));
    }

    if (data) {
      setIsLookup(data.isLookup ?? true);
      setIsRequire(data.isRequire || false);
      setIsOriginal(data.isOriginal ?? false);
      setContentRequire(data.contentRequire || "");
    }
  }, [formData, initData, data]);

  const handleAddField = (profileIndex, sectionIndex) => {
    const sectionKey = `${profileIndex}-${sectionIndex}`;
    const section = formData.profiles[profileIndex].data[sectionIndex];

    const newFields = section.fields[0].map((field) => ({
      ...field,
      value: "",
    }));
    setSectionData((prevState) => {
      const updatedFields = [...prevState[sectionKey][0].fields, ...newFields];

      return {
        ...prevState,
        [sectionKey]: [
          {
            ...prevState[sectionKey][0],
            fields: updatedFields,
          },
        ],
      };
    });
  };

  const handleRemoveFieldGroup = (
    sectionKey,
    sectionInstanceId,
    groupStart,
    groupSize,
  ) => {
    const keyPrefix = `${sectionKey}-${sectionInstanceId}-`;

    const removeAndReindexValues = (previous) => {
      const next = {};

      Object.entries(previous).forEach(([key, value]) => {
        if (!key.startsWith(keyPrefix)) {
          next[key] = value;
          return;
        }

        const oldIndex = Number(key.slice(keyPrefix.length));
        if (
          Number.isNaN(oldIndex) ||
          (oldIndex >= groupStart && oldIndex < groupStart + groupSize)
        ) {
          return;
        }

        const newIndex =
          oldIndex > groupStart ? oldIndex - groupSize : oldIndex;
        next[`${keyPrefix}${newIndex}`] = value;
      });

      return next;
    };

    setFormState(removeAndReindexValues);
    setFiles(removeAndReindexValues);
    setSectionData((previous) => ({
      ...previous,
      [sectionKey]: previous[sectionKey].map((sectionInstance) =>
        sectionInstance.id === sectionInstanceId
          ? {
              ...sectionInstance,
              fields: sectionInstance.fields.filter(
                (_, fieldIndex) =>
                  fieldIndex < groupStart ||
                  fieldIndex >= groupStart + groupSize,
              ),
            }
          : sectionInstance,
      ),
    }));
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (!["image/jpeg", "image/png"].includes(file.type)) {
  //     toast.error("Chỉ chấp nhận định dạng JPEG/PNG.");
  //     return;
  //   }

  //   if (file.size > 2 * 1024 * 1024) {
  //     toast.error("Kích thước tệp vượt quá 2MB.");
  //     return;
  //   }

  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setImageSrc(reader.result || "/images/logo.png");
  //   };
  //   reader.onerror = () => {
  //     toast.error("Không thể đọc tệp. Vui lòng thử lại.");
  //   };
  //   reader.readAsDataURL(file);

  //   setImageFile(file);
  // };

  const handleChange = (fieldName, value, sectionKey, uniqueId, fieldIdx) => {
    setFormState((prev) => ({
      ...prev,
      [`${sectionKey}-${uniqueId}-${fieldIdx}`]: value,
    }));
  };

  const handleFileChange = (
    fieldName,
    files,
    sectionKey,
    uniqueId,
    fieldIdx,
  ) => {
    const key = `${sectionKey}-${uniqueId}-${fieldIdx}`;

    setFiles((prev) => {
      const updatedFiles = { ...prev };

      if (files.length > 0) {
        updatedFiles[key] = files; // Cập nhật danh sách file mới
      } else {
        delete updatedFiles[key]; // Nếu không còn file nào, xóa key khỏi object
      }

      return updatedFiles;
    });
  };

  const transformFormData = () => {
    const transformed = [];
    Object.keys(sectionData).forEach((sectionKey) => {
      sectionData[sectionKey].forEach((sectionInstance) => {
        const sectionName = sectionInstance.name;
        const fields = sectionInstance.fields.map((field, fieldIdx) => {
          const key = `${sectionKey}-${sectionInstance.id}-${fieldIdx}`;

          let value = formState[key] || "";
          if (field.type === "select" && value && value.label) {
            value = value.label;
          }

          return {
            name: field.name,
            value,
            fieldType: field.type,
          };
        });
        transformed.push({
          type: sectionName || "unknown",
          fields,
        });
      });
    });
    return transformed;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = [];
    if (brand && !brand.trim()) {
      errors.push("Nhãn hiệu là bắt buộc.");
    }

    if (represent.companyName && !represent.companyName.trim()) {
      errors.push("Tên tổ chức đại diện là bắt buộc.");
    }
    if (represent.address && !represent.address.trim()) {
      errors.push("Địa chỉ tổ chức đại diện là bắt buộc.");
    }
    Object.keys(sectionData).forEach((sectionKey) => {
      sectionData[sectionKey].forEach((sectionInstance) => {
        sectionInstance.fields.forEach((field, fieldIdx) => {
          const key = `${sectionKey}-${sectionInstance.id}-${fieldIdx}`;
          const value = formState[key] || "";

          if (field.required && !value) {
            errors.push(`${field.name} là trường bắt buộc.`);
          }
        });
      });
    });

    if (isRequire && !contentRequire.trim()) {
      const message = "Vui lòng nhập nội dung yêu cầu khác.";
      setContentRequireError(message);
      errors.push(message);
    } else {
      setContentRequireError("");
    }

    if (errors.length > 0) {
      errors.forEach((error) => toast.error(error));
      return;
    }

    const transformedData = transformFormData();
    const formDataPayload = new FormData();
    formDataPayload.append("info", JSON.stringify(transformedData));
    formDataPayload.append("represent", JSON.stringify(represent));
    formDataPayload.append("brand", brand);
    formDataPayload.append("isLookup", isLookup);
    formDataPayload.append("isRequire", isRequire);
    formDataPayload.append("isOriginal", isOriginal);
    formDataPayload.append("contentRequire", contentRequire);

    // Xác định key cuối cùng trong sectionData
    const sectionKeys = Object.keys(sectionData);
    const lastSectionKey = sectionKeys[sectionKeys.length - 1];

    let galleryArray = [];

    sectionData[lastSectionKey]?.forEach((sectionInstance) => {
      sectionInstance.fields.forEach((field, fieldIdx) => {
        const key = `${lastSectionKey}-${sectionInstance.id}-${fieldIdx}`;

        const currentValue = formState[key];
        const newFiles = files[key];

        if (!currentValue && !newFiles) {
          galleryArray.push("null");
          return;
        }

        if (!currentValue && newFiles) {
          galleryArray.push(newFiles);
          return;
        }

        if (currentValue && !newFiles) {
          galleryArray.push(currentValue);
          return;
        }

        if (currentValue && newFiles) {
          const merged = Array.isArray(currentValue)
            ? [...currentValue, ...newFiles]
            : [currentValue, ...newFiles];
          galleryArray.push(merged);
          return;
        }
      });
    });

    var galleryOrder = [];
    // galleryArray.forEach((file, index) => {
    //   if (file !== null) {
    //     formDataPayload.append("gallery", file); // Chỉ gửi file thật sự
    //   }
    //   if (file)
    //     galleryOrder.push(
    //       file === "null"
    //         ? "null"
    //         : typeof file === "string" && file.trim() !== ""
    //         ? galleryArray[index]
    //         : file.length === 1
    //         ? "file"
    //         : "multiFile"
    //     ); // Đánh dấu vị trí null
    // });

    galleryArray.forEach((item) => {
      if (item === null || item === "null") {
        galleryOrder.push("null");
      } else if (Array.isArray(item)) {
        let url_count = 0;
        let fileCount = 0;

        item.forEach((file) => {
          formDataPayload.append("gallery", file);
          if (typeof file === "string") {
            url_count++;
          } else {
            fileCount++;
          }
        });

        galleryOrder.push(url_count + "-" + fileCount);
      } else {
        formDataPayload.append("gallery", item);
        if (typeof item === "string") {
          galleryOrder.push("1-0");
        } else {
          galleryOrder.push("0-1");
        }
      }
    });

    formDataPayload.append("galleryOrder", JSON.stringify(galleryOrder));

    // for (let pair of formDataPayload.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    try {
      setLoading(true);

      if (!isEdit) {
        await formService.add_new(id, formDataPayload, serviceId, token_client);
      } else {
        await formService.update(id, formDataPayload, token_client);
      }

      toast.success("Đăng ký dịch vụ và tạo hồ sơ thành công!");
    } catch (error) {
      toast.dismiss();
      toast.error(error.response?.data?.message || "Có lỗi xảy ra.");
      console.error("Submit Error:", error);
    } finally {
      setLoading(false);
      if (!isEdit) navigate("/quan-ly-ho-so");
      else {
        navigate(`/quan-ly-ho-so/ho-so/${id}`);
      }
    }
  };

  const renderDragDropField = (
    field,
    fieldKey,
    currentValue,
    onRemoveItem,
    onAppendFiles,
  ) => {
    if (Array.isArray(currentValue)) {
      return (
        <div className="space-y-3">
          {currentValue.length > 0 && (
            <ul className="space-y-2">
              {currentValue.map((url, index) => (
                <li
                  key={index}
                  className="hover:border-blue-300 border-blue-600 border-2 flex items-center justify-between w-full bg-gray-100 p-2 py-4 rounded-md"
                >
                  <div className="flex gap-2 items-center">
                    <img
                      src="/images/document.png"
                      alt="Icon"
                      className="size-[20px]"
                    />
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600 hover:underline break-all text-sm"
                    >
                      {(() => {
                        const fileName = url?.split("/").pop();

                        return fileName?.length > 50
                          ? `${fileName.substring(0, 47)}...`
                          : fileName;
                      })()}
                    </a>
                  </div>

                  <button type="button" onClick={() => onRemoveItem(index)}>
                    <img
                      src="/icons/x-close.svg"
                      alt="Remove"
                      className="h-4 w-4"
                    />
                  </button>
                </li>
              ))}
            </ul>
          )}

          <DragDrop
            label="Tải thêm tài liệu"
            onFileChange={(newFiles) => {
              if (newFiles?.length > 0) {
                onAppendFiles(newFiles);
              }
            }}
            maxFiles={field.maxValue - currentValue.length}
          />
        </div>
      );
    }

    if (typeof currentValue === "string" && currentValue.trim() !== "") {
      return (
        <div className="border-2 w-full border-solid rounded-md p-4 text-center cursor-pointer relative flex flex-col justify-center items-center space-y-4 hover:border-blue-300 border-blue-600">
          <div className="flex items-center justify-start w-full">
            <label
              htmlFor={field.name}
              className="block text-sm text-gray-500 cursor-pointer"
            >
              <div className="flex gap-2 items-center ">
                <img
                  src="/images/document.png"
                  alt="Icon"
                  className="size-[20px]"
                />
                <a
                  href={formState[`${fieldKey}`]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-blue-600 hover:underline break-all text-sm"
                >
                  {(() => {
                    // Extract the filename from the URL
                    const fileName = formState[`${fieldKey}`]?.split("/").pop();

                    // Check if the filename length exceeds 50 characters
                    return fileName?.length > 50
                      ? `${fileName.substring(0, 47)}...`
                      : fileName;
                  })()}
                </a>
              </div>
            </label>
            <button
              type="button"
              onClick={() =>
                setFormState((prev) => ({
                  ...prev,
                  [`${fieldKey}`]: "",
                }))
              }
              className="absolute right-2"
            >
              <img src="/icons/x-close.svg" alt="Remove" className="h-4 w-4" />
            </button>
          </div>
        </div>
      );
    }

    return (
      <DragDrop
        label="Kéo thả file để tải lên"
        onFileChange={(files) => {
          setFiles((prev) => ({
            ...prev,
            [fieldKey]: files,
          }));
        }}
        maxFiles={field.maxValue}
      />
    );
  };

  let sectionCounter = 0;

  if (loading) {
    return (
      <div
        className={`flex ${
          isMobile ? "h-screen w-screen" : "h-full"
        } items-center justify-center`}
      >
        <Loading />
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className="w-full h-[calc(100%-20px)]">
        <div className="h-[calc(100%-54px)] overflow-auto bg-[#F2F2F2]">
          <div className="h-[calc(100%-20px)] overflow-auto">
            <div className="space-y-4 p-3">
              <div className="space-y-4">
                <h2 className="font-sf-semibold">
                  {category === "Nhãn hiệu" ? "Nhãn hiệu:" : "Tên hồ sơ:"}
                </h2>
                <div className={`grid grid-cols-1 gap-4`}>
                  <CustomInput
                    placeholder={
                      category === "Nhãn hiệu"
                        ? "Nhãn hiệu (nếu có)"
                        : "Tên hồ sơ (nếu có)"
                    }
                    // required
                    value={brand}
                    onChange={(value) => setBrand(value)}
                  />
                </div>
              </div>
              {formData.profiles?.map((profile, profileIdx) => (
                <div key={profileIdx} className={`grid grid-cols-1 gap-4`}>
                  {profile.data?.map((section, secIdx) => {
                    const sectionKey = `${profileIdx}-${secIdx}`;
                    sectionCounter += 1;

                    return (
                      <div key={secIdx} className="space-y-4">
                        <h2 className="font-sf-semibold">
                          {sectionCounter}. {section.type}
                        </h2>
                        {sectionData[sectionKey]?.map((sectionInstance) => (
                          <div
                            key={sectionInstance.id}
                            className={`grid grid-cols-1 ${
                              section.type === "Danh mục hàng hóa/dịch vụ"
                                ? "gap-8"
                                : "gap-4"
                            }`}
                          >
                            {sectionInstance.fields.map((field, fieldIdx) => {
                              const fieldKey = `${sectionKey}-${sectionInstance.id}-${fieldIdx}`;
                              const groupSize = section.fields[0].length;
                              const isCategorySection =
                                section.type ===
                                "Danh mục hàng hóa/dịch vụ";
                              const isGroupStart =
                                isCategorySection &&
                                fieldIdx % groupSize === 0;
                              const canRemoveGroup =
                                isCategorySection &&
                                fieldIdx % groupSize === 0;
                              const isRemovableGroup = isCategorySection;
                              const isFile =
                                field.type === "pdf" || field.type === "image";
                              const isSelect = field.type === "select";

                              const FieldComponent = isFile
                                ? DragDrop
                                : isSelect
                                  ? CustomSelect
                                  : CustomInput;

                              return (
                                <div
                                  key={fieldIdx}
                                  className={`relative col-span-1 ${
                                    isRemovableGroup ? "pr-12" : ""
                                  }`}
                                >
                                  {isGroupStart && (
                                    <div
                                      aria-hidden="true"
                                      className="pointer-events-none absolute -inset-x-2 -top-1 h-[calc(200%+2.5rem)] rounded-xl bg-[#F7F8FA]"
                                    />
                                  )}
                                  {canRemoveGroup && (
                                    <button
                                      type="button"
                                      aria-label={`Gỡ ${section.type}`}
                                      title={`Gỡ ${section.type}`}
                                      onClick={() =>
                                        handleRemoveFieldGroup(
                                          sectionKey,
                                          sectionInstance.id,
                                          fieldIdx,
                                          groupSize,
                                        )
                                      }
                                      className="absolute -right-2 -top-1 z-20 flex h-[calc(200%+2.5rem)] w-11 items-center justify-center rounded-r-xl bg-[#FF5A5F] text-2xl text-white transition-colors hover:bg-red-600"
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  )}
                                  <div className="relative z-10">
                                  {isFile ? (
                                    <>
                                      <h2 className="font-sf-semibold mb-2">
                                        + {field.name}
                                      </h2>
                                      {renderDragDropField(
                                        field,
                                        fieldKey,
                                        formState[fieldKey],
                                        (removeIndex) => {
                                          const updated = formState[
                                            fieldKey
                                          ].filter((_, i) => i !== removeIndex);
                                          setFormState((prev) => ({
                                            ...prev,
                                            [fieldKey]: updated,
                                          }));
                                        },
                                        (newFiles) => {
                                          setFiles((prev) => ({
                                            ...prev,
                                            [fieldKey]: newFiles,
                                          }));
                                        },
                                      )}
                                    </>
                                  ) : (
                                    <FieldComponent
                                      key={fieldIdx}
                                      label={
                                        isFile
                                          ? "Kéo thả file để tải lên"
                                          : field.name
                                      }
                                      options={
                                        isSelect ? NhomSelectData : undefined
                                      }
                                      placeholder={field.name}
                                      type={
                                        field.type === "email"
                                          ? "email"
                                          : "text"
                                      }
                                      required={field.required || false}
                                      isTextarea={field.textarea || false}
                                      value={formState[fieldKey] || ""}
                                      onChange={(value) =>
                                        handleChange(
                                          field.name,
                                          value,
                                          sectionKey,
                                          sectionInstance.id,
                                          fieldIdx,
                                        )
                                      }
                                      onFileChange={(file) =>
                                        handleFileChange(
                                          field.name,
                                          file,
                                          sectionKey,
                                          sectionInstance.id,
                                          fieldIdx,
                                        )
                                      }
                                    />
                                  )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ))}
                        {section.add && (
                          <div className="mt-4">
                            <button
                              type="button"
                              className="text-blue-600 gap-1 hover:font-bold flex items-center"
                              onClick={() => handleAddField(profileIdx, secIdx)}
                            >
                              <img src="/icons/add-circle.svg" alt="Add icon" />
                              Thêm{" "}
                              <span className="lowercase"> {section.type}</span>
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>

            <AdditionalInfoFields
              compact
              contentRequire={contentRequire}
              error={contentRequireError}
              isLookup={isLookup}
              isOriginal={isOriginal}
              isRequire={isRequire}
              onContentRequireChange={setContentRequire}
              onLookupChange={setIsLookup}
              onOriginalChange={setIsOriginal}
              onRequireChange={setIsRequire}
            />

            <div className="flex flex-wrap mt-2 w-full gap-3 p-3">
              <Button
                variant="secondary"
                type="reset"
                onClick={() => {
                  if (
                    window.confirm(
                      "Bạn có chắc chắn muốn hủy chỉnh sửa hồ sơ này không?",
                    )
                  ) {
                    setFormState({});
                    setFiles({});
                    navigate("/quan-ly-ho-so");
                  }
                }}
              >
                Hủy
              </Button>
              <Button type="submit" variant="primary" onClick={handleSubmit}>
                Nộp hồ sơ
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-10 pt-0 rounded-lg shadow-lg h-full overflow-auto">
      <div className="flex justify-center items-center gap-6 mb-6">
        {/* {isEdit && (
          <div className="flex items-center">
            <label
              htmlFor="image-upload"
              className="cursor-pointer w-28 h-28 bg-gray-100 flex items-center justify-center rounded-md overflow-hidden relative hover:opacity-60"
            >
              {imageSrc ? (
                <img
                  src={imageSrc}
                  alt="Uploaded"
                  className="w-full h-full object-contain"
                />
              ) : (
                <div className="flex items-center justify-center text-gray-400">
                  <img src="/icons/camera-icon.svg" alt="Camera icon" />
                </div>
              )}

              <input
                id="image-upload"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleImageChange}
              />
            </label>
          </div>
        )} */}
        {/* <h1 className="text-3xl font-bold text-blue-600 uppercase">
          {serviceName}
        </h1> */}
      </div>

      <div className="space-y-4">
        {/* {isEdit && (
          <div className="space-y-4">
            <h2 className="font-sf-semibold">Tổ chức đại diện SHCN:</h2>
            <div className={`grid grid-cols-1 gap-4`}>
              <CustomInput
                placeholder={"Tên tổ chức đại diện"}
                required
                value={represent.companyName}
                onChange={(value) =>
                  handleRepresentChange("companyName", value)
                }
              />
              <CustomInput
                placeholder={"Địa chỉ tổ chức đại diện"}
                required
                value={represent.address}
                onChange={(value) => handleRepresentChange("address", value)}
              />
            </div>
          </div>
        )} */}
        <div className="space-y-4">
          <h2 className="font-sf-semibold">
            {category === "Nhãn hiệu" ? "Nhãn hiệu:" : "Tên hồ sơ:"}
          </h2>
          <div className={`grid grid-cols-1 gap-4`}>
            <CustomInput
              placeholder={
                category === "Nhãn hiệu"
                  ? "Nhãn hiệu (nếu có)"
                  : "Tên hồ sơ (nếu có)"
              }
              // required
              value={brand}
              onChange={(value) => setBrand(value)}
            />
          </div>
        </div>
        {formData.profiles?.map((profile, profileIdx) => (
          <div
            key={profileIdx}
            className={`grid grid-cols-${profile.cols} gap-4`}
          >
            {profile.data?.map((section, secIdx) => {
              const sectionKey = `${profileIdx}-${secIdx}`;
              sectionCounter += 1;

              return (
                <div key={secIdx} className="space-y-4">
                  <h2 className="font-sf-semibold">
                    {sectionCounter}. {section.type}
                  </h2>
                  {sectionData[sectionKey]?.map((sectionInstance) => (
                    <div
                      key={sectionInstance.id}
                      className={`grid grid-cols-${section.cols} gap-x-4 ${
                        section.type === "Danh mục hàng hóa/dịch vụ"
                          ? "gap-y-8"
                          : "gap-y-4"
                      }`}
                    >
                      {sectionInstance.fields.map((field, fieldIdx) => {
                        const fieldKey = `${sectionKey}-${sectionInstance.id}-${fieldIdx}`;
                        const groupSize = section.fields[0].length;
                        const isCategorySection =
                          section.type === "Danh mục hàng hóa/dịch vụ";
                        const isGroupStart =
                          isCategorySection && fieldIdx % groupSize === 0;
                        const canRemoveGroup =
                          isCategorySection &&
                          fieldIdx % groupSize === 0;
                        const isRemovableGroup = isCategorySection;
                        const isGroupEnd =
                          isCategorySection &&
                          (fieldIdx + 1) % groupSize === 0;
                        const isFile =
                          field.type === "pdf" || field.type === "image";
                        const isSelect = field.type === "select";

                        const FieldComponent = isFile
                          ? DragDrop
                          : isSelect
                            ? CustomSelect
                            : CustomInput;

                        return (
                          <div
                            key={fieldIdx}
                            className={`relative col-span-${field.span || 1} ${
                              isRemovableGroup && isGroupEnd ? "pr-14" : ""
                            }`}
                          >
                            {isGroupStart && (
                              <div
                                aria-hidden="true"
                                className="pointer-events-none absolute -bottom-3 -left-3 -top-3 -right-[calc(100%+1rem)] rounded-xl bg-[#F7F8FA]"
                              />
                            )}
                            {canRemoveGroup && (
                              <button
                                type="button"
                                aria-label={`Gỡ ${section.type}`}
                                title={`Gỡ ${section.type}`}
                                onClick={() =>
                                  handleRemoveFieldGroup(
                                    sectionKey,
                                    sectionInstance.id,
                                    fieldIdx,
                                    groupSize,
                                  )
                                }
                                className="absolute -right-[calc(100%+1rem)] -top-3 z-20 flex h-[calc(100%+1.5rem)] w-12 items-center justify-center rounded-r-xl bg-[#FF5A5F] text-2xl text-white transition-colors hover:bg-red-600"
                              >
                                <span aria-hidden="true">×</span>
                              </button>
                            )}
                            <div className="relative z-10">
                            {isFile ? (
                              <>
                                <h2 className="font-sf-semibold mb-2">
                                  + {field.name}
                                </h2>
                                {renderDragDropField(
                                  field,
                                  fieldKey,
                                  formState[fieldKey],
                                  (removeIndex) => {
                                    const updated = formState[fieldKey].filter(
                                      (_, i) => i !== removeIndex,
                                    );
                                    setFormState((prev) => ({
                                      ...prev,
                                      [fieldKey]: updated,
                                    }));
                                  },
                                  (newFiles) => {
                                    setFiles((prev) => ({
                                      ...prev,
                                      [fieldKey]: newFiles,
                                    }));
                                  },
                                )}
                              </>
                            ) : (
                              <FieldComponent
                                key={fieldIdx}
                                label={
                                  isFile
                                    ? "Kéo thả file để tải lên"
                                    : field.name
                                }
                                options={isSelect ? NhomSelectData : undefined}
                                placeholder={field.name}
                                type={field.type === "email" ? "email" : "text"}
                                required={field.required || false}
                                isTextarea={field.textarea || false}
                                value={formState[fieldKey] || ""}
                                onChange={(value) =>
                                  handleChange(
                                    field.name,
                                    value,
                                    sectionKey,
                                    sectionInstance.id,
                                    fieldIdx,
                                  )
                                }
                                onFileChange={(file) =>
                                  handleFileChange(
                                    field.name,
                                    file,
                                    sectionKey,
                                    sectionInstance.id,
                                    fieldIdx,
                                  )
                                }
                              />
                            )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                  {section.add && (
                    <div className="mt-4">
                      <button
                        type="button"
                        className="text-blue-600 gap-1 hover:font-bold flex items-center"
                        onClick={() => handleAddField(profileIdx, secIdx)}
                      >
                        <img src="/icons/add-circle.svg" alt="Add icon" />
                        Thêm <span className="lowercase"> {section.type}</span>
                      </button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <AdditionalInfoFields
        contentRequire={contentRequire}
        error={contentRequireError}
        isLookup={isLookup}
        isOriginal={isOriginal}
        isRequire={isRequire}
        onContentRequireChange={setContentRequire}
        onLookupChange={setIsLookup}
        onOriginalChange={setIsOriginal}
        onRequireChange={setIsRequire}
      />

      <div className="flex justify-end mt-10 space-x-4">
        <button
          type="reset"
          onClick={() => {
            if (
              window.confirm(
                "Bạn có chắc chắn muốn hủy chỉnh sửa hồ sơ này không?",
              )
            ) {
              setFormState({});
              setFiles({});
              navigate("/quan-ly-ho-so");
            }
          }}
          className="py-2 px-6 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
        >
          Hủy
        </button>
        <button
          onClick={handleSubmit}
          className="py-2 px-6 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Nộp hồ sơ
        </button>
      </div>
    </div>
  );
};

export default DynamicForm;
